import { ContentBlock } from 'draft-js';
import { findWithRegex } from '../../draft-js-utils/src';

const SPECIAL_EMOJI_REGEX = `:[-()d]|\\<3|;\\)|=\\)`;
const EMOJI_REGEX = `(\\s|^):\\+1|${SPECIAL_EMOJI_REGEX}|:[\\w]{2,}:?`;

const emojiSuggestionsStrategy = (contentBlock: ContentBlock, callback: StrategyCallback): void => {
  findWithRegex(new RegExp(EMOJI_REGEX, 'g'), contentBlock, callback);
};

export default emojiSuggestionsStrategy;
